module.exports = __webpack_public_path__ + "static/media/logopartypay.2510ae7f.svg";